import * as BaseSizes from './Size';

export const Size = {
  XXSmall: BaseSizes.Medium,
  XSmall: BaseSizes.Large,
  Small: BaseSizes.XLarge,
  Medium: BaseSizes.X2Large,
  Large: BaseSizes.X4Large,
  XLarge: BaseSizes.X7Large,
  XXLarge: BaseSizes.X8Large,
};
